<template>
  <v-container fill-height>
    <v-row align="center" justify="center" dense>
      <v-col class="py-12">
        <v-card
          elevation="6"
          class="mx-auto"
          variant="outlined"
          color="grey lighten-3"
          rounded="xxl"
          :height="$vuetify.breakpoint.mdAndDown ? 'fit-content' : '600px'"
        >
          <v-card-text>
            <v-row>
              <v-col md="6" sm="6" lg="6" align-self="center">
                <v-img
                  :src="
                    is_company_user
                      ? `${mediaUrl + logo_path}`
                      : require('../../assets/healthy-tantra-logo.png')
                  "
                  alt="SAPP"
                  class="mx-auto"
                  width="200"
                ></v-img>
              </v-col>
              <v-col align-self="center" md="6" sm="6" lg="6" class="py-auto">
                <v-card
                  color="px-4 grey lighten-4 ma-auto"
                  rounded="xl"
                  :height="
                    $vuetify.breakpoint.mdAndDown ? 'fit-content' : '565px'
                  "
                >
                  <v-card-title class="text-h4 mb-1 font-weight-bold"
                    >Welcome{{ is_company_user ? " back" : "" }}</v-card-title
                  >
                  <v-card-subtitle class="font-weight-bold"
                    >Welcome{{ is_company_user ? " back" : "" }}, Please enter
                    your details.</v-card-subtitle
                  >
                  <v-card-text>
                    <v-text-field
                      v-model="form.email"
                      outlined
                      solo
                      rounded
                      label="Email"
                      placeholder="Enter email address"
                      clearable
                      @click:clear="form.email = null"
                      prepend-inner-icon="mdi-email"
                      :error-messages="errors.email"
                    ></v-text-field>
                    <v-text-field
                      v-model="form.password"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPassword ? 'text' : 'password'"
                      outlined
                      solo
                      rounded
                      @keypress.enter="login"
                      :error-messages="errors.password"
                      label="Password"
                      placeholder="Enter password"
                      prepend-inner-icon="mdi-lock"
                      @click:append="showPassword = !showPassword"
                    ></v-text-field>
                    <v-alert
                      v-if="loginError"
                      type="error"
                      dense
                      outlined
                      class="mb-3 text-caption"
                    >
                      {{ loginError }}
                    </v-alert>
                    <v-btn
                      :loading="isLoading"
                      :disabled="isLoading"
                      color="primary"
                      block
                      rounded
                      @click="login"
                    >
                      Login
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      align="right"
                      to="/forgot-password"
                    >
                      Forgot password?
                    </v-btn>
                    <v-divider class="my-4"></v-divider>
                    <div class="text-center">
                      <v-btn
                        text
                        color="secondary"
                        @click="switchToSellerLogin"
                        small
                      >
                        <v-icon small left>mdi-store</v-icon>
                        Are you a Seller? Login here
                      </v-btn>
                    </div>
                  </v-card-text>
                </v-card>
                <!-- <span>{{ errorMsg }}</span> -->
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Inactive User Dialog -->
    <v-dialog v-model="showInactiveDialog" max-width="450" persistent>
      <v-card rounded="lg">
        <v-card-title class="text-h5 error white--text">
          <v-icon left color="white">mdi-account-off</v-icon>
          Account Inactive
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert type="warning" outlined class="mb-4">
            <div class="text-body-1">
              Your account is currently <strong>inactive</strong>.
            </div>
          </v-alert>
          <p class="text-body-1 mb-2">
            You are unable to access the system at this time. Please contact the administrator for further assistance.
          </p>
          <v-divider class="my-3"></v-divider>
          <p class="text-caption grey--text mb-0">
            <v-icon small class="mr-1">mdi-information</v-icon>
            <strong>Note:</strong> If you believe this is an error, please reach out to the support team with your registered email address.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="showInactiveDialog = false"
            rounded
          >
            <v-icon left>mdi-close</v-icon>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Access Restricted Dialog -->
    <v-dialog v-model="showAccessRestrictedDialog" max-width="450" persistent>
      <v-card rounded="lg">
        <v-card-title class="text-h5 error white--text">
          <v-icon left color="white">mdi-shield-lock</v-icon>
          Access Restricted
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert type="error" outlined class="mb-4">
            <div class="text-body-1">
              You do not have permission to access the <strong>Admin Panel</strong>.
            </div>
          </v-alert>
          <p class="text-body-1 mb-2">
            Only users with <strong>Super Admin</strong> or <strong>Admin</strong> roles can login to the admin panel.
          </p>
          <v-divider class="my-3"></v-divider>
          <p class="text-caption grey--text mb-0">
            <v-icon small class="mr-1">mdi-information</v-icon>
            If you are a seller, please use the <strong>Seller Login</strong> page instead.
          </p>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-btn
            text
            color="secondary"
            @click="showAccessRestrictedDialog = false; switchToSellerLogin();"
            small
          >
            <v-icon small left>mdi-store</v-icon>
            Go to Seller Login
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="showAccessRestrictedDialog = false"
            rounded
          >
            <v-icon left>mdi-close</v-icon>
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "@/axios";
// Import mixin is not needed since it's globally registered in main.js

export default {
  name: "LoginPage",
  data() {
    return {
      form: {
        email: "",
        password: "",
        portal: true,
      },
      loggedInRole: "",
      logo_path: "../../assets/healthy-tantra-healthy-tantra-logo.png",
      is_company_user: false,
      showPassword: false,
      isLoading: false,
      loginError: null,
      showInactiveDialog: false,
      showAccessRestrictedDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      isSeller: "auth/isSeller",
      isAdmin: "auth/isAdmin",
      isSuperAdmin: "auth/isSuperAdmin",
    }),
  },
  mounted() {
    const companyId = localStorage.getItem("company-id");
    if (companyId && companyId.length > 0) {
      this.getCompany(companyId);
      console.log(companyId);
    }
  },
  methods: {
    async getCompany(companyId) {
      await axios
        .get(`/get_company/${this.encryptIt(companyId)}`)
        .then((company) => {
          company = company.data.data;
          this.logo_path = company.logo_path;
          // this.is_company_user = true;
        })
        .catch((error) => {
          this.logo_path =
            "../../assets/healthy-tantra-healthy-tantra-logo.png";
          console.error("Error fetching data:", error);
        });
    },
    ...mapActions({
      logIn: "auth/logIn",
      logOut: "auth/logOut",
    }),
    switchToSellerLogin() {
      const currentUrl = window.location;
      let sellerUrl;

      if (currentUrl.hostname === 'localhost' || currentUrl.hostname === '127.0.0.1') {
        // For local development, just redirect to seller login component
        this.$router.push('/seller-login');
        return;
      } else if (currentUrl.hostname === 'admin.healthytantra.com') {
        sellerUrl = 'https://seller.healthytantra.com/seller-login';
      } else if (currentUrl.hostname === 'healthytantra.aaibuzz.com') {
        sellerUrl = 'https://seller.healthytantra.aaibuzz.com/seller-login';
      } else {
        // For other environments, construct seller subdomain
        const hostname = currentUrl.hostname.replace(/^admin\./, '');
        sellerUrl = `${currentUrl.protocol}//seller.${hostname}${currentUrl.port ? ':' + currentUrl.port : ''}/seller-login`;
      }

      window.location.href = sellerUrl;
    },
    async login() {
      this.isLoading = true;
      this.loginError = null;
      try {
        await this.logIn(this.form);
        this.isLoading = false;

        // Only SUPER ADMIN and ADMIN roles can login from admin panel
        if (!this.isAdmin && !this.isSuperAdmin) {
          this.logOut();
          this.showAccessRestrictedDialog = true;
          return;
        }

        this.$router.push("/home");
      } catch (error) {
        console.error("Login error:", error);
        this.isLoading = false;
        if (error.isInactiveUser) {
          this.showInactiveDialog = true;
        } else {
          const msg = error.response?.data?.message;
          const status = error.response?.status;
          if (status === 401) {
            this.loginError = msg || 'Invalid email or password.';
          } else if (status === 422) {
            this.loginError = msg || 'Please enter your email and password.';
          } else {
            this.loginError = msg || 'Login failed. Please try again.';
          }
        }
      }
    },
  },
};
</script>
